import { useEffect, useRef } from "react";
import { toast } from "sonner";

/**
 * Listens for online/offline events and shows discreet toasts
 * so the user understands they are reading from the offline cache.
 */
export const OfflineIndicator = () => {
  const wasOnline = useRef(typeof navigator === "undefined" ? true : navigator.onLine);

  useEffect(() => {
    const handleOffline = () => {
      if (wasOnline.current) {
        toast.info("Mode hors-ligne", {
          description: "Vous lisez les chapitres déjà consultés depuis le cache.",
          duration: 4000,
        });
        wasOnline.current = false;
      }
    };

    const handleOnline = () => {
      if (!wasOnline.current) {
        toast.success("Connexion rétablie");
        wasOnline.current = true;
      }
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  return null;
};

export default OfflineIndicator;
